import React, {useState, useEffect, useRef} from 'react';
import {useDispatch} from 'react-redux';
import {Camera} from '../types';
import {toggleCamera} from '../actions';
import TimeoutIntervalMisc from '../miscs/TimeoutIntervalMisc';
// @ts-ignore
import { Player, LoadingSpinner, BigPlayButton, ControlBar, PlayToggle } from 'video-react';

type Props = {
  vehicleName: string,
  camera: Camera
  style: {width: number, height: number}
}

const Streaming = ( props: Props ) => {
  const dispatcher = useDispatch();
  const [loading, setLoading] = useState(false);
  const { camera, vehicleName, style } = props;
  const { id, channel } = camera;
  const refVideo = useRef(null);
  const streamingBodyStyle = { height: style.height - 10 }
  const streamingSectionStyle = {width: style.width - 12, height: style.height - 41};
  useEffect( () => {
    if ( loading ) {
      TimeoutIntervalMisc.setTimeout( `${id}-${channel}-loading`, () => {
        return setLoading(false);
      }, 1000 );
    }
  });
  return ( <div className='Streaming' style={props.style} onContextMenu={(e) => {e.stopPropagation(); e.preventDefault()}}>
    <div className='Streaming-body' style={streamingBodyStyle}>
      <section className='streaming-top-bar'>
        <span className='vehicle-name no-selection ellipsis'>{vehicleName}</span>
        <span className='camera-name no-selection ellipsis'>{camera.title}</span>
        <span
          className='icon icon-close'
          onClick={ () => {
            dispatcher( toggleCamera( {camera, toggleTo: false} ) );
          } }></span>
        <span
          className='icon icon-refresh'
          onClick={ () => {
            setLoading( true );
          } }></span>
      </section>
      <section className='video-streaming' style={streamingSectionStyle}>
        {loading && (
          <div className='video-loading-outer'>
            <div className='video-loading' style={{ top: (streamingSectionStyle.height - 120 ) /2 }}/>
          </div>
        )}
        {!loading && (<Player
            fluid={false}
            ref={refVideo}
            width={streamingSectionStyle.width}
            height={streamingSectionStyle.height}
            src={`/stream?carPlate=${id}&channel=${channel}&ovs_url=${camera.ovs_url}`}
        >
          <LoadingSpinner/>
          <BigPlayButton position="center"/>
          <ControlBar disableDefaultControls={true}>
            <PlayToggle/>
          </ControlBar>
        </Player>)}
      </section>
    </div>
  </div> );
}

export default Streaming;
